export default "__VITE_ASSET__DEInErXC__"